import axios from "axios";

// Si estamos en desarrollo usando el puerto de React (3000), apuntamos al backend local (5280).
// En producción, el SPA es servido por la propia API, por lo que usamos el origin actual.
const isDevReactPort = typeof window !== "undefined" && window.location.port === "3000";
const API_URL = process.env.REACT_APP_API_URL || (isDevReactPort ? "http://localhost:5280" : window.location.origin);

export const api = axios.create({
  baseURL: `${API_URL}/api`,
});

export { API_URL };

export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common.Authorization;
  }
}
